import { useState } from 'react';
import createStyles from '@guestyci/foundation/createStyles';

const useClasses = createStyles(
  () => ({
    overlay: {
      position: 'fixed',
      width: '100vw',
      height: '100vh',
      backgroundColor: 'transparent',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      // z-index should place the overlay in front of other objects in the header
      // but behind the search results themselves.
      zIndex: 2,
    },
    wrapper: {
      position: 'relative',
    },
  }),
  { name: 'PopUp-Wrapper' }
);

interface IPopUpContainerProps {
  children: (props: {
    isVisible: boolean;
    onOpen: () => void;
    onClose: () => void;
  }) => JSX.Element;
  onOverlayClick?: () => void;
}

function PopUpContainer({ children, onOverlayClick }: IPopUpContainerProps) {
  const classes = useClasses();
  const [isVisible, toggleVisibility] = useState(false);

  function onClose() {
    toggleVisibility(false);
    onOverlayClick?.();
  }

  function onOpen() {
    toggleVisibility(true);
  }

  return (
    <>
      <div className={classes.wrapper}>
        {children({
          isVisible,
          onOpen,
          onClose,
        })}
      </div>

      {/*
       The overlay is a transparent, clickable element that closes the popup.
       It prevents the user from interacting with other content on the page
       (e.g., links) while the popup is open.
      */}
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      {isVisible && <div className={classes.overlay} onClick={onClose} />}
    </>
  );
}

export default PopUpContainer;
